/* istanbul ignore file */

import uuidV4 from 'uuid/v4';
import {
  createDeleteBody,
  createFormDataWithFields,
  createSubmitBody,
  getDeleteResponseOutcome,
  getSubmitResponseOutcome,
  getUploadResponseOutcome,
} from './docUploadCommon';
import deleteDocs, { submitDocs } from './util';

export const uploadDocument = ({
  docUploadUrl,
  formDataProps,
  file,
  documentId,
  onStartUploadCall,
  onProgress,
}) => new Promise((resolve) => {
  const formData = createFormDataWithFields(formDataProps);
  formData.append('file', file);
  formData.append('fileType', file.type);
  formData.append('documentId', documentId);

  if (onStartUploadCall) {
    onStartUploadCall();
  }

  const xhr = new XMLHttpRequest();
  xhr.withCredentials = true;
  xhr.upload.addEventListener('progress', (event) => {
    if (onProgress) {
      onProgress(event);
    }
  });
  xhr.addEventListener('load', (event) => {
    const res = JSON.parse(event.target.response);
    resolve({
      response: res,
      outcome: getUploadResponseOutcome(res),
    });
  });
  xhr.addEventListener('error', () => {
    resolve({
      response: null,
      outcome: 'uploadApiError',
    });
  });
  xhr.open('POST', `${docUploadUrl}/servicing/v1/communications/docs`);
  xhr.setRequestHeader('icaas-correlation-id', uuidV4());
  xhr.send(formData);
});

export const deleteDocument = ({
  dispatch,
  documentId,
  fileId,
  formDataProps,
}) => deleteDocs(
  dispatch,
  documentId,
  fileId,
  createDeleteBody(formDataProps)
).then((res) => ({
  response: res,
  outcome: getDeleteResponseOutcome(res),
}));

export const submitDocument = ({
  dispatch,
  documentId,
  formDataProps,
}) => submitDocs(
  dispatch,
  createSubmitBody(formDataProps, documentId)
).then((res) => ({
  response: res,
  outcome: getSubmitResponseOutcome(res),
}));
